import { render, staticRenderFns } from "./PerformanceMetricsComponent.vue?vue&type=template&id=01ae44f8&scoped=true&"
import script from "./PerformanceMetricsComponent.vue?vue&type=script&lang=js&"
export * from "./PerformanceMetricsComponent.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceMetricsComponent.vue?vue&type=style&index=0&id=01ae44f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae44f8",
  null
  
)

export default component.exports